/// <reference path="./HTML.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class Tag extends HTML {

        /**
         *
         * @param name
         * @returns {HTMLElement}
         */
        protected static createElement(name: string) {
            return document.createElement(name);
        }

        public addAttribute(name: string, value: string) {
            this.setAttribute(name, this.translate(value));
        }

        public addAttributes(attributes: Map<string, any>[]) {
            const me = this;
            attributes.forEach((a: Map<string, any> | { n: string, v }) => {
               // if ()
                if (a instanceof Map) {
                    me.addAttribute(a.get("n"), a.get("v"));
                } else {
                    me.addAttribute(a.n, a.v);
                }
            });
        }

        public equals(value: any) {
            return this === value;
        }

        /**
         *
         * @returns {Array<Tag>}
         */
        public getChildren() {
            const els = this.getElement().childNodes as NodeListOf<HTMLElement>;
            const result: Tag[] = [];
            for (const el of els) {
                result.push(new Tag(el));
            }

            return result;
        }

        public fixHeight() {
            const t: HTMLElement = this.getElement();
            const cs = window.getComputedStyle(t);
            t.style.height = "inherit";
            const height = parseInt(cs.getPropertyValue("border-top-width"), 10)
                + parseInt(cs.getPropertyValue("padding-top"), 10)
                + t.scrollHeight
                + parseInt(cs.getPropertyValue("padding-bottom"), 10)
                + parseInt(cs.getPropertyValue("border-bottom-width"), 10);

            t.style.height = height + "px";

        }

        public focus() {
            this.getElement().focus();
        }

        public insertOnTop(tag: Tag) {
            const el: Element = this.getElement();
            el.insertBefore(tag.getElement(), el.firstChild);
        }

        public show() {
            this.removeClass("hide");
            this.addClass("show");
            this.getElement().style.display = this.get("visibility");
        }

        public hide(defaut?: any) {
            this.removeClass("show");
            this.addToData("visibility", this.getVisibility(defaut));
            this.addClass("hide");
        }

        /**
         *
         * @returns {number}
         */
        public countChildren() {
            return this.getElement().childNodes.length;
        }

        public clear(): this {
            const element: Element = this.getElement();
            if (element) {
                element.innerHTML = "";
            }

            return this;
        }

        /**
         *
         * @returns {string|any}
         */
        public getContent() {
            return this.getElement().innerHTML;
        }

        public getStripText() {
            const text = this.getText();

            return text.replace(/<[^>]*>/g, "");
        }

        /**
         *
         * @returns {string|any}
         */
        public getText() {
            const t = this.getElement().textContent || this.getElement().innerText;
            return t;//.trim();
        }

        /**
         *
         * @param names
         */
        public addClasses(names: []) {
            names.forEach((c: string) => {
                this.addClass(c);
            });
        }

        /**
         *
         * @param name
         */
        public addClass(name: string) {
            if (name && (typeof name === "string") && name.startsWith("#")) {
                name = this.translate(name);
            }
            this.getElement().classList.add(name);
        }

        /**
         *
         * @param names
         */
        public removeClasses(names: []) {
            names.forEach((c: string) => {
                this.removeClass(c);
            });
        }

        /**
         *
         * @param name
         */
        public removeClass(name: string) {
            this.getElement().classList.remove(name);
        }

        public onClick(func: any, blockClickDelay:number = 1000) {
            const me = this;

            this.addListener("click", (e) => {
                if (me.isDisabled()) {
                    return;
                }
                me.disable();
                func(e);
                timeout(() => {
                    me.enable();
                }, blockClickDelay);
            });
            me.enable();
        }


        private isDisabled() {
            return this.getAttribute("e") !== "1";
        }

        private disable() {
            return this.addAttribute("e", "");
        }

        private enable() {
            return this.addAttribute("e", "1");
        }

        /**
         *
         * @param func
         */
        public onChange(func: any) {
            this.addListener("change", func);
        }

        /**
         *
         * @param name
         * @param value
         */
        public setAttribute(name: string, value: any) {
            this.getElement().setAttribute(name, value);
        }

        /**
         *
         * @param names
         * @param skipNull
         */
        public getAttributes(names: string[], skipNull?: boolean) {
            const element: Element = this.getElement();
            const result = new Map();
            if (element) {
                names.forEach((name: string) => {
                    const v = element.getAttribute(name);
                    if (!skipNull || v) {
                        result.set(name, v);
                    }
                });
            }

            return result;
        }

        /**
         *
         * @returns {string}
         */
        public getId() {
            return this.get("id");
        }

        /**
         *
         * @param id
         */
        public setId(id: string | number) {
            this.addToData("id", id);
            this.getElement().setAttribute("id", id);
        }

        public getValue() {
            return this.getElement().value;
        }

        /**
         *
         * @param filter
         */
        public querySelector(filter: string) {
            return this.getElement().querySelector(filter);
        }

        /**
         * @returns {any}
         */
        public getElementId() {
            return this.getAttribute("id");
        }

        /**
         * @param name
         * @returns {any|string}
         */
        public getAttribute(name: string) {
            return this.getElement().getAttribute(name);
        }

        /**
         * @param text
         */
        public setText(text: string | number) {
            this.getElement().innerText = text;
        }

        /**
         * @param element
         */
        public appendChild(element: any) {
            if (element instanceof HAObject) {
                element = element.getElement();
            }
            this.getElement().appendChild(element);
        }

        /**
         * @param element
         */
        public addFistChild(element: any) {
            if (element instanceof HAObject) {
                element = element.getElement();
            }
            this.getElement().insertAdjacentElement("afterbegin", element);
        }

        /**
         *
         * @param id
         */
        public removeById(id: string) {
            this.getElement().removeChild(this.findElementById(id));
        }

        /**
         * @param attributeName
         * @returns {any}
         */
        public findByAttribute(attributeName: string) {
            const element = this.findElementByAttribute(attributeName);
            if (element) {
                return new Tag(element);
            }
            return null;
        }

        public findElementByAttribute(attributeName: string): HTMLElement {
            const element = this.getElement() || this.getParentElement() || document;
            return element.querySelector("[" + attributeName + "]") as HTMLElement;
        }

        public findElementByQuery(name: string): HTMLElement {
            const element = this.getElement() || this.getParentElement() || document;
            return element.querySelector(name) as HTMLElement;
        }

        public findByQuery(name: string): Tag {
            const element = this.getElement() || this.getParentElement() || document;
            return new Tag(element.querySelector(name) as HTMLElement);
        }

        /**
         *
         * @param id
         * @param useDoc
         */
        public findById(id: string, useDoc: boolean = false) {
            const element = this.findElementById(id, useDoc);
            if (element) {
                return new Tag(element);
            }
            return null;
        }

        /**
         *
         * @param id
         * @param useDoc
         */
        public findElementById(id: string, useDoc: boolean = false) {
            try {
                const element = (useDoc) ? document : this.getElement() || this.getParentElement() || document;
                return element.querySelector("#" + id + "") as HTMLElement;
            } catch ( e) {
                return null;
            }
        }

        /**
         *
         * @param tagName
         * @returns {HTMLElement}
         */
        public findByTag(tagName: string) {
            const element = this.getElement() || this.getParentElement() || document;
            return element.querySelector("" + tagName + "") as HTMLElement;
        }

        /**
         *
         * @param tagName
         * @returns {Array<Tag>}
         */
        public fetchByTagName(tagName: string) {
            const element = this.getElement() || this.getParentElement() || document;
            const els = element.querySelectorAll(tagName) as NodeListOf<HTMLElement>;
            const result: Tag[] = [];
            for (const el of els) {
                result.push(new Tag(el));
            }

            return result;
        }

        /**
         *
         * @param attributeName
         * @returns {Array<Tag>}
         */
        public fetchByAttribute(attributeName: string) {
            const element = this.getElement() || this.getParentElement() || document;
            const els = element.querySelectorAll("[" + attributeName + "]") as NodeListOf<HTMLElement>;
            const result: Tag[] = [];
            for (const el of els) {
                result.push(new Tag(el));
            }

            return result;
        }

        public invisible() {
            this.addClass("invisible");
        }

        /**
         * @returns {string}
         */
        public getTagName() {
            return this.get("_tn") || "div";
        }

        public addListener(name: string, func: any) {
            if ((typeof func) === "function") {
                this.getElement().addEventListener(name, (event: Event) => {
                    //  log2(event);
                    func(event);
                    event.stopPropagation();
                }, { passive: true });
            }
        }

        public translate(word: string | any, translation?: any): any {
            if (!word || !(typeof word === "string") || !word.startsWith("#")) {
                return word;
            }
            translation = translation || toMap(this.get("trans"));
            const word2 = translation.get(word.substr(1));
            if (word2 !== undefined) {
                return word2;
            }
            return null;
        }

        public scrollIntoView(): void {
            this.getElement().scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
        }

        protected hasTrans(word: string | any, translation?: any): any {
            if (!word || !(typeof word === "string") || !word.startsWith("#")) {
                return false;
            }
            translation = translation || toMap(this.get("trans"));
            const word2 = translation.get(word.substr(1));
            if (word2 !== undefined) {
                return true;
            }
            return false;
        }

        protected createByType(data: Map<any, any>, main: Tag): void {
            HA.Core.HTML.Service.HtmlService.createByType(data, main, toMap(this.get("trans")));
        }

        protected translateAll(list: Map<any, any>): Map<any, any> {
            const rep: Map<any, any> = new Map();
            const me = this;
            list.forEach((v: any, k: string) => {
                rep.set(k, me.translate(v));
            });

            return rep;
        }

        /**
         * @param id
         * @returns {any}
         */
        protected trans(id: any) {
            return this.translate(this.getData().get(id));
        }

        protected createByTypeAndAddAll(children: [] | string, tag: Tag) {
            if (typeof children === "string" || typeof children === "number") {
                const tchildren: string | number = this.translate(children);
                if (this instanceof Span || this instanceof P) {
                    this.setText(tchildren);
                } else {
                    this.appendChild(new Span(tchildren));
                }
                return;
            } else if (children && Array.isArray(children) || children instanceof Map) {
                const me = this;
                const trans = this.get("trans");
                try {
                    children.forEach((item: string | number | any) => {
                        if (typeof item === "string" || typeof item === "number") {
                            const titem: string | number = this.translate(item);
                            if (this instanceof Span) {
                                this.setText(titem);
                            } else {
                                this.appendChild(new Span(titem));
                            }
                            return;
                        }
                        const nitem = toMap(item);
                        if (nitem.size === 0) {
                            return;
                        }
                        if (trans) {
                            nitem.set("trans", trans);
                        }
                        me.createByType(nitem, tag);
                    });
                } catch (e) {
                    log("ooups!");
                    ptime(e);
                    throw e;
                }
            }
        }

        protected getVisibility(defaut?: any) {
            return this.getElement().style.display || defaut;
        }

        protected searchAndAddElement() {
            let param: any;
            let element: Element;
            param = this.get("id");
            if (param) {
                element = this.findElementById(param);
            }
            if (!element) {
                param = this.get("attribute");
                if (param) {
                    element = this.findElementByAttribute(param);
                }
                if (!element) {
                    param = this.get("html");
                    if (param) {
                        const el = document.createElement("div");
                        el.innerHTML = this.translate(param);
                        element = el.firstChild as Element;
                    }
                    if (!element) {
                        param = this.get("tagName");
                        if (param) {
                            element = this.findByTag(param);
                        } else {
                            this.createSelf();
                            return;
                        }
                    }
                }
            }
            this.setElement(element);
        }

        /**
         *
         * @param element
         * @returns {Map<String, any>}
         */
        protected setElement(element?: Element) {
            return this.addToData("element", element);
        }

        protected getParentElement() {
            return this.get("pelement");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: Map<any, any> | Tag | Element | HAObject | any) {

            if ((data instanceof Object)
                && !(data instanceof Map)
                && !(data instanceof Element)
                && !(data instanceof HAObject)) {
                data = toMap(data);
            }

            if (data instanceof Map && data.has("tag")) {
                const t:Tag = data.get("tag");
                data.set("element", t.getElement());
            } else {
                if (data instanceof Element) {
                    data = toMap({element: data});
                } else if (data instanceof HAObject) {
                    data = toMap({element: data.getElement()});
                }
            }

            super.initialize(data);
            if (!this.getElement()) {
                this.searchAndAddElement();
            }

            if (typeof data === "string") {
                this.setText(this.translate(data));
            }

            if (this.has("txt")) {
                this.setText(this.translate(this.get("txt")));
            }

            if (this.has("onClick")) {
                this.onClick(this.get("onClick"));
            } else if (this.has("click")) {
                this.onClick(this.get("click"));
            }

            if (this.has("onChange")) {
                this.onChange(this.get("onChange"));
            }
            if (this.has("className")) {
                this.addClass(this.get("className"));
            }
            if (this.has("classes")) {
                this.addClasses(this.get("classes"));
            }
            if (this.has("class")) {
                const _class =  this.get("class");
                if (typeof _class === "string" ) {
                    this.addClass(_class);
                } else {
                    this.addClasses(_class);
                }
            }
            if (this.has("attributes")) {
                this.addAttributes(this.get("attributes"));
            }
            if (this.has("-events")) {
                this.initEvents(this.get("-events"));
            }
            if (this.has("eid")) {
                this.setId(this.translate(this.get("eid")));
            }
        }

        protected initEvents(events: Map<string, () => void>) {
            const me = this;
            events.forEach((func: () => void, name: string) => {
                me.addListener(name, func);
            });
        }

        protected createSelf() {
            if (!this.get("element")) {
                this.setElement(Tag.createElement(this.getTagName()));
            }
            if (this.has("c")) {
                this.createByTypeAndAddAll(this.get("c"), this);
            }
        }

        protected replaceValues(data: any) {

            if (data === "undefined" || (typeof data === "number")) {
                return data;
            }
            const r = new RegExp("#.+");

            if ((typeof data === "string") && !(r.test(data))) {
                return data;
            }

            if ((typeof data === "string")) {
                return this.translate(data);
            }

            if (data instanceof Map || Array.isArray(data) || typeof data === "object") {
                const d = toMap(data);
                if (d.has("norepl")) {
                    return data;
                }
                const me = this;
                const data2 = new Map<any, any>();
                data.forEach((item, index) => {
                    let v = item;
                    if (!(typeof item === "string") && !(typeof item === "number")) {
                        v = toMap(v);
                    }
                    const v2 = me.replaceValues(v);
                    data[index] = v2;
                    data2.set(index, v2);
                });

                return data2;
            }

            return data;
        }
    }
}
